import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'app-start',
  templateUrl: './start.component.html',
  styleUrls: ['./start.component.scss']
})
export class StartComponent {

  @Output() onStartClicked: EventEmitter<void> = new EventEmitter<void>();

  clickStart(): void {
    this.onStartClicked.emit();
  }
}
